export const PleaseSelectAgt = () => {
	return <div className="pad-1rem has-text-centered">Bitte wählen Sie eine Agentur für diesen Bericht aus</div>;
};
